import { render, staticRenderFns } from "./procedureMatrix.vue?vue&type=template&id=5d5e8327&scoped=true"
import script from "./procedureMatrix.vue?vue&type=script&lang=js"
export * from "./procedureMatrix.vue?vue&type=script&lang=js"
import style0 from "./procedureMatrix.vue?vue&type=style&index=0&id=5d5e8327&prod&lang=less&scoped=true"
import style1 from "./procedureMatrix.vue?vue&type=style&index=1&id=5d5e8327&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e8327",
  null
  
)

export default component.exports